<template>
  <!-- needed ref="thead" to eliminate the vuesax error -->
  <tbody ref="thead">
    <vs-tr
      :data="tr"
      :key="indextr"
      v-for="(tr, indextr) in rows"
    >
      <vs-td>
        <vs-chip :color="getOrderStatusColor(tr.status)">{{tr.status}}</vs-chip>
      </vs-td>
      <vs-td>
        <p>{{ (tr.location || {}).name || 'N/a' }}</p>
      </vs-td>
      <!-- <vs-td>
        <p>{{ (tr.hostedBy || {}).firstName || 'N/a' }}</p>
      </vs-td> -->
      <vs-td>
        <p>{{ tr.checkinTime | longDate }}</p>
      </vs-td>
      <vs-td>
        <p v-if="tr.checkoutTime">{{ tr.checkoutTime | longDate }}</p>
        <vs-button
          v-if="!tr.checkoutTime"
          size="small"
          class
          @click.stop.prevent="signoutVisit(tr)"
          icon-pack="feather"
          icon="icon-check"
          icon-before
        >Sign Out</vs-button>
      </vs-td>
      <vs-td>
        <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" />
        <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteItem(tr.id)" />
      </vs-td>
    </vs-tr>
  </tbody>
</template>

<script>
export default {
  props: ['rows', 'methods'],
  methods: {
    async clicktr (tr) {
      const visit = await this.fetchVisit(tr.id);
      if (visit) {
        this.$root.$tcPopup.show({
          data: visit,
          classes: 'vs-dialog--md',
          title: `${this.$options.filters.fullDate(visit.checkinTime || visit.checkoutTime)}${visit.visitor.email ? `: ${visit.visitor.email}` : ''}`,
          component: 'ViewVisit',
          buttonsHidden: true
        })
      }
    }, // needed to eliminate the error this.$parent.clicktr,
    async signoutVisit (tr) {
      const visitId = tr.id;
      this.methods.signout(visitId);
    },
    deleteItem (id) {
      this.$store.dispatch('visitManagement/deleteVisitById', { id, route: this.$route });
    },
    async fetchVisit(visitId) {
      return await this.$store.dispatch('visitManagement/fetchVisit', { id: visitId });
    },
  },
  mounted() {}
};
</script>
